import React from "react";

export default function InlineKeepTogether({ children, style }) {
  return (
    <span style={{ display: "inline-block", whiteSpace: "nowrap", ...style }}>
      {children}
    </span>
  );
}
